/**
 * Repères du référentiel La Bécane — partagés backend et seed.
 */

/**
 * `companyId` Bécane des **franchises** du Groupe TDS : leurs sites sont hors inventaire, comme
 * les collaborateurs franchisés (voir `docs/decisions.md` §3.1).
 *
 * C'est le **contrat commercial du site** (son `companyId`) qui fait foi, décidé par le métier —
 * pas le rattachement d'un collaborateur, qui raterait les sites de franchise sans personnel et
 * inclurait à tort les rares sites sous-traités en interne sur un contrat de franchise. Ces
 * exceptions sont assumées : le `companyId` prime.
 */
export const FRANCHISE_COMPANY_IDS: readonly number[] = [10, 14, 15, 16, 17, 18, 19, 20];

/** Le site relève-t-il d'une franchise ? (via son `companyId` Bécane) */
export function isFranchiseCompany(companyId?: number | null): boolean {
  return companyId != null && FRANCHISE_COMPANY_IDS.includes(companyId);
}
